import type { AiAppCenterModule } from '../types'

/** 后端 system_module.name=scenic；独立窗正式 key/path 为 scenicarea */
export const scenicModule: AiAppCenterModule = {
  key: 'scenicarea',
  label: 'AI智慧景区',
  desc: '景区信息 / 票务配置 / 游客服务',
  path: '/scenicarea',
  standalonePath: '/scenicarea/dashboard',
  homePath: '/scenicarea/dashboard',
  // 侧栏菜单仍挂在后端 /scenic 下
  menuPaths: ['/scenic'],
  icon: 'ep:location',
  color: '#22c55e',
  aliases: ['AI 智慧景区', '智慧景区', '景区管理']
}
